function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { cloneElement, Component, createRef, Children } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import classNames from '../utils/classNames';
import GridList from '../GridList';
var rootClassName = 'psw-preview-grid-list';
var ADDONS_PREVIEW_ITEMS_MAX = 6;
/**
 * Display a portion of a collection items allowing the ability to see all.
 *
 * ## Composed Of
 * - [GridList](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/GridList)
 * - [Button](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Button)
 *
 * ## Usage
 * ```jsx
 * <PreviewGridList
 *   previewSize="s"
 *   viewMoreLabel={format('string', 'msg_view_more')}
 * >
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 * </PreviewGridList>
 * ```
 */

var PreviewGridList = /*#__PURE__*/function (_Component) {
  _inherits(PreviewGridList, _Component);

  var _super = _createSuper(PreviewGridList);

  function PreviewGridList(props) {
    var _this;

    _classCallCheck(this, PreviewGridList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldShowAllItems: false
    });

    _defineProperty(_assertThisInitialized(_this), "_computeViewMore", function () {
      var rootEl = _this.root.current;
      if (!rootEl) return;

      var items = _toConsumableArray(rootEl.querySelectorAll(".".concat(rootClassName, " > ul > li")));

      var totalItemCount = items.length;
      var visibleItemCount = items.filter(function (x) {
        return getComputedStyle(x).display !== 'none';
      }).length;

      if (visibleItemCount < totalItemCount) {
        rootEl.classList.add('psw-has-more');
      } else {
        rootEl.classList.remove('psw-has-more');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onViewMore", function (event) {
      var _this$props$onViewMor = _this.props.onViewMore,
          onViewMore = _this$props$onViewMor === void 0 ? _this.showAllItems : _this$props$onViewMor;
      onViewMore({
        showAllItems: function showAllItems() {
          return _this.showAllItems(event);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveElement", function (element, event) {
      var isKeyboardAction = event.detail === 0;

      if (isKeyboardAction && element) {
        element.childNodes[0].focus({
          preventScroll: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "showAllItems", function (event) {
      var rootEl = _this.root.current;
      if (!rootEl) return;

      var items = _toConsumableArray(rootEl.querySelectorAll(".".concat(rootClassName, " > ul > li")));

      var firstHiddenElement = items.find(function (x) {
        return getComputedStyle(x).display === 'none';
      });

      _this.setState({
        shouldShowAllItems: true
      }, function () {
        return _this.setActiveElement(firstHiddenElement, event);
      });
    });

    _this.root = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(PreviewGridList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._computeViewMore();

      window.addEventListener('resize', this._computeViewMore);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._computeViewMore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          cta = _this$props.cta,
          children = _this$props.children,
          className = _this$props.className,
          gridClassName = _this$props.gridClassName,
          previewSize = _this$props.previewSize,
          itemSize = _this$props.itemSize,
          viewMoreLabel = _this$props.viewMoreLabel,
          dataTrack = _this$props.dataTrack,
          trackClick = _this$props.trackClick,
          telemetryMeta = _this$props.telemetryMeta;
      var shouldShowAllItems = this.state.shouldShowAllItems;

      if (!shouldShowAllItems) {
        this._computeViewMore();
      }

      var childrenArray = Children.toArray(children);
      return /*#__PURE__*/React.createElement("div", {
        ref: this.root,
        className: classNames(className, rootClassName)
      }, /*#__PURE__*/React.createElement(GridList, {
        qa: qa,
        className: classNames(gridClassName, !shouldShowAllItems && "psw-preview-size-".concat(previewSize), previewSize === 's' && childrenArray.length < ADDONS_PREVIEW_ITEMS_MAX && "psw-item-count-".concat(childrenArray.length)),
        itemSize: itemSize
      }, children), !shouldShowAllItems && /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-preview-grid-list-cta', 'psw-t-align-c', 'psw-m-t-6')
      }, /*#__PURE__*/React.isValidElement(cta) && /*#__PURE__*/cloneElement(cta, {
        ctaType: 'tertiary',
        onClick: this.onViewMore
      }), !cta && /*#__PURE__*/React.createElement(Button, {
        qa: "".concat(qa, "#btn"),
        ctaType: "tertiary",
        onClick: this.onViewMore,
        dataTrack: dataTrack,
        trackClick: trackClick,
        telemetryMeta: telemetryMeta
      }, viewMoreLabel)));
    }
  }]);

  return PreviewGridList;
}(Component);

PreviewGridList.defaultProps = {
  qa: '',
  cta: null,
  className: '',
  gridClassName: '',
  previewSize: 's',
  children: [],
  viewMoreLabel: 'Show More',
  itemSize: 's',
  onViewMore: undefined,
  dataTrack: null,
  trackClick: null,
  telemetryMeta: null
};
PreviewGridList.propTypes = {
  /**
   * QA Selector for validation testing
   */
  qa: PropTypes.string,

  /**
   *The cta associated with the preview, used to view more details. Include telemetry props here
   * if passing in your own cta. It will not fallback to the component's telemetry props.
   */
  cta: PropTypes.node,

  /**
   * CSS Classes to apply to the preview grid list root, mainly for applying any additional
   * margin
   */
  className: PropTypes.string,

  /**
   * The items to place and render within the preview grid
   */
  children: PropTypes.arrayOf(PropTypes.node),

  /**
   * CSS Classes to apply to the grid. Useful for adjusting the item alignment
   */
  gridClassName: PropTypes.string,

  /**
   * Controls how many items are previewed
   */
  previewSize: PropTypes.oneOf(['s', 'm']),

  /**
   * Controls the number of items that can fit in a row
   */
  itemSize: PropTypes.oneOf(['s', 'm']),

  /**
   * The View More CTA label
   */
  viewMoreLabel: PropTypes.string,
  onViewMore: PropTypes.func,

  /**
   * Data attribute read by PDC data layer when user clicks on the button
   */
  dataTrack: PropTypes.string,

  /**
   * The spec id identifying the interaction
   */
  trackClick: PropTypes.string,

  /**
  * Serialized JSON data of context specific telemetry data
  */
  telemetryMeta: PropTypes.string
};
export default PreviewGridList;